export default class BrowserUtils {
  /**
   * Identifica se o usuário está acessando a aplicação através de um navegador DESKTOP ou MOBILE
   * @returns
   */
  static isMobile() {
    const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }
}
